import { type OpenDockLoadTypes } from '../domain/Shipment'

export function formatLoadTypeInfo(loadType: OpenDockLoadTypes, withName = false) {
  const baseValues = `${loadType.operation} - ${loadType.equipmentType} - ${loadType.mode} - ${loadType.duration}m`

  return withName ? `${loadType.name} - ${baseValues}` : baseValues
}
